import * as React from 'react';
import {Link as RouterLink} from 'react-router-dom';

import {Link} from 'shells/link/link';

import styles from '../login-form.module.css';

type Props = {
    emailValue: string | null | undefined;
};

export function SignupSection(props: Props) {
    return (
        <div className={styles['login-container']}>
            Don’t have an account?{' '}
            <Link
                // @ts-expect-error
                as={RouterLink}
                variant='primary'
                size='normal'
                to={{
                    pathname: '/signup',
                    search: props.emailValue ? `?email=${props.emailValue}` : undefined,
                }}
            >
                Sign up now
            </Link>
        </div>
    );
}
